import { HERMES_URL } from "resources/constants";
import authClient from "lib/axios/clients";
import { map as _map, forEach as _forEach } from "lodash";

const mapUsers = rawUsers => {
  const mappedUsers = _map(rawUsers, rawUser => {
    const mappedUser = {
      ...rawUser
    };
    _forEach(rawUser.Attributes, attr => {
      mappedUser[attr.Name] = attr.Value;
    });

    delete mappedUser.Attributes;

    return mappedUser;
  });

  return mappedUsers;
};

export const getUsers = async params => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/users`,
    params
  };

  return authClient.request(config);
};

export const getMappedUsers = async params => {
  const rawUsers = (await getUsers(params)).data;

  return mapUsers(rawUsers);
};

export const createUser = user => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/users`,
    data: user
  };

  return authClient.request(config);
};

export const partialUpdateUser = user => {
  const config = {
    method: "PATCH",
    url: `${HERMES_URL}/users/${user.id}`,
    data: user
  };

  return authClient.request(config);
};

export const deleteUser = userId => {
  const config = {
    method: "DELETE",
    url: `${HERMES_URL}/users/${userId}`
  };

  return authClient.request(config);
};

export const getUserSpecificTenants = userId => {
  const config = {
    method: "GET",
    url: `${HERMES_URL}/users/${userId}/athena_tenants`
  };

  return authClient.request(config);
};

export const validateUserEmail = userId => {
  const config = {
    method: "POST",
    url: `${HERMES_URL}/users/${userId}/validate_email`
  };

  return authClient.request(config);
};
